<span [pTooltip]="btnHint" tooltipPosition="top" *ngIf="btnIcon">
    <button pButton class="p-button-danger" type="button" [icon]="btnIcon" (click)="click()" [disabled]="btnDisabled"></button>
</span>
